import {Box} from "@mui/material";
import React from "react";

interface BackdropOverlayProps {
  onClick: () => void;
}
export const BackdropOverlay = ({ onClick }: BackdropOverlayProps) => (
  <Box className="relative" onClick={onClick}>
    <Box
      className="absolute bg-black bg-opacity-50 backdrop-blur-sm z-20"
      style={{width: '100%', height: 2000}}
    />
  </Box>
)